import React, { useState, memo, useEffect } from 'react'
import _ from '/home/ps/root'
import { equal, copy } from '../../../global'
import { getJson, getMediaOf } from '../part/field'
import {tcp} from '../../../io'
const ID = 'more'
const once = {}
const More = prop => {
  const {connected, verb: mverb, login, vendor, route, cookie, mid, lang, owner, u, view, master} = prop.master
  const park = prop.park
  const {db, v: _v} = prop
  // const fid = prop.row && prop.body.id
  const fid = prop.row && prop.body?.id
  const verb = prop.row?.verb || mverb
  // const v = fid==ITEMS ? _.ITEM : _v
  const v = _.JSON_[fid] || _v
  // const {pk, sell} = prop.table
  // if (prop.name=='items') debugger
  const {storeConfig, sell} = prop.table
  // if (!prop.table.pk)debugger
  const pk = route.length > 2 && !isNaN(route[2]) ? route[2] : null
  if (pk) return null
  // if (!_.JSON_[fid]) return null
  // switch (fid) {
  //   case FILES:
  //   case REVIEWS:
  //   case ITEMS:
  //   break
  //   default: if (prop.row) return null
  // }
  // if (prop.row && prop.more.length && prop.body.id!=FILES) return null
  // if (prop.row && prop.more.length && (!(fid==FILES || fid==ITEMS))) return null
  if (!prop.row && prop.more.length && (!_.JSON_[fid])) debugger
  if (prop.row && prop.more.length && (!_.JSON_[fid])) debugger
  if (prop.row && prop.more.length && (!_.JSON_[fid])) return null
// if (fid==ITEMS && prop.row.verb==_.UPD)debugger
  if ((db < 0 || !(park[v] && park[v][db]) || connected) && fid!='items') return null
  // if ((db < 0 || !(park[v] && park[v][db]) || connected)) return null
  const printer = park[v] && park[v][verb]
  const store = park[v]?.[db] || {}
  const nextOffset = print => {
    var offset = 0
    while (store[`${offset}${print}`]) {
      // console.log(`nextOffset.present ${offset} print${print}`)
      offset += _.LIMIT
    }
    // console.log('nextOffset', {ID, offset, print})
    return offset
  }
  const rows = store.default
  const _rows = Object.keys(rows||{})
  if (_rows.length==1 && _rows[0]<0) return null // only one negative row
  const [print, setPrint] = useState(store.print || _.PUB)
  const [offset, setOffset] = useState(store.offset || 0)
  // const [more, setMore] = useState(prop.more.slice(_.LIMIT))
  const [more, setMore] = useState(prop.more.reduce((acc, pk, i) => {
    if (!prop.value.includes(pk)) acc.push(pk)
    return acc
  }, []))//.slice(_.LIMIT))
    // .slice(_.LIMIT))
  // if (fid=='items')debugger
  const countPublic = store[_.PUB]
  const pub =  store[`${offset}${_.PUB}`]
  const countPrivate = store[_.PRI]
  const pri =  store[`${offset}${_.PRI}`]
  // const morePublic = countPublic ? countPublic - nextOffset(_.PUB) : 0
  // const morePrivate = countPrivate ? countPrivate - nextOffset(_.PRI) : 0
  const printerPrint = printer && printer.part.print
  const morePublic = countPublic && (countPublic - nextOffset(_.PUB))
  const morePrivate = countPrivate && (countPrivate - nextOffset(_.PRI))
// if (prop.row && prop.body.id=='items')debugger
// if (fid==ITEMS && prop.compact)debugger
  // const children = fid==ITEMS ? prop.more : more
  const children = _.JSON_[fid] ? prop.more : more
// if (v=='review')debugger
// if (prop.row && pk>0 && prop.row.verb=='upd')debugger
// if (prop.row) {debugger}
// else {debugger}
  // if (prop.value && prop.value.length>=prop.more.length) return null
  if (prop.value && prop.value>0 && prop.value.length>=prop.more.length) {debugger;return null}
// if (prop.json)debugger
  if (morePublic<0 && morePrivate<0 && !children.length) {debugger;return null}
  if (prop.more && children.reduce((acc, pk, i) => {
    const f = getMediaOf(lang, vendor.home, park, db, pk, prop.body?.id)
    if (!f) acc.push(pk)
    return acc
  }, []).length==0) return null
  const onClick = e => {
    if (e) {
      e.stopPropagation()
      e.preventDefault()
      console.log('onClick', {ID, name: e.target.name, type: e.target.type, id: e.target.id, checked: e.target.checked})
    }
    console.log('onClick', {ID, print})
    // console.log(`More.onClick name ${print} ${e.target.name}, type ${e.target.type}, id ${e.target.id}, checked ${e.target.checked}`, prop)
    // console.log('onClick', {ID, print, name: e.target.name, type: e.target.type, id: e.target.id, checked: e.target.checked})
    const buff = {[v]: {default: 'find', [db]: {}}}
    const value = []
    // export const getJson = (park, lang, shard, db, id, value) => {
    // const value = getJson(park, lang, vendor.home, db, prop.body?.id, children)
    // if (prop.body.id=='items' && prop.control) debugger
    // export const getMediaOf = (lang, shard, park, db, pk, id) => {
    // const value =
    if (children.length) {
      let j = 0
// if (v=='review')debugger
      buff[v][db].default = children.reduce((acc, pk, i) => {
        const f = getMediaOf(lang, vendor.home, park, db, pk, prop.body?.id)
        if (f || f=='find' || prop.value.includes(pk)) return acc
        // if (prop.value.includes(pk)) return acc
        // if (!more.includes(pk)) {
        // if (!(i<_.LIMIT)) return acc
        if (!(j++<_.LIMIT)) return acc
        // j++
        // acc.push(pk)
        acc[pk] = 'find'
        value.push(pk)
        // }
        return acc
      }, {})
      // let i=0
      // while (i < _.LIMIT) {
      //   buff[v][db].default = {}
      //
      // }
      // for (let i = 0; i < _.LIMIT; i++) {
      //   if (more[i]) {
      //     buff[v][db].default[more[i]] = _.FIND
      //     json.push(more[i])
      //   }
      // }
    } else {
if (v=='review')debugger
      buff[v][db].offset = nextOffset(print)
      buff[v][db].print = print
      if (!store[print]) buff[v][db].count = print
      buff[v][db].default = [] // must be after after offset, print, count for request.php to work
    }
    tcp({
      // debug: ID,
      lang,
      u: v,
      id: route,
      buffer: {[vendor.home]: buff},
    // }, owner && _.PRIVATE_.includes(v) ? cookie.home : vendor.home)
    }, cookie.p)
    // if (prop.meta && !prop.control) prop.setWakeup({meta: prop.meta, wakeup: buff})
    setMore(more.slice(_.LIMIT))
// if (prop.body.id=='items' && prop.control && prop.table.pk==5) debugger
    if (prop.callback) prop.callback(value)
  }
  if (fid=='items' && verb!='default' && pk>0 && !once[pk]) {
  // if (fid=='items' && (verb!='default' || prop.control) && (pk>0 || prop.table.pk>0) && !once[pk]) {
    once[pk || prop.table.pk] = true
    onClick()
  }
  // if (fid==ITEMS && verb!=_.DEF && pk>0 && once[pk]) debugger
  const id = `${ db }${ v }${ prop.table.pk }${ prop.body?.id }more`
  const bp = { onClick }
  const lp = { htmlFor: id, className: 'more l' }
  const ip = {
    id,
    type: 'checkbox',
    checked: print==_.PUB,
    className: 'more input',
    disabled: !printerPrint,
    onChange: e => {
      e.stopPropagation()
      const nprint = e.target.checked ? _.PUB : _.PRI
      // console.log(`More.onChange ${v} print${print} nprint${nprint} e.target.checked${e.target.checked}`)
      console.log('onChange', {ID, v, print, nprint, checked: e.target.checked})
      setPrint(nprint)
      setOffset(nextOffset(nprint))
    },
  }
  // const labelProp = {key: `${id}label`}
  // const inputProp   = {key: `${id}input`}
  // const label = <span {...labelProp}> <label {...lp}>{/*master.more.i*/} {master.print.i}</label> </span>
  // const input = <span {...inputProp}> <input {...ip}/> </span>
  const label = <span key={`${id}label`}> <label {...lp}>{/*master.more.i*/} {master.print.i}</label> </span>
  const input = <span key={`${id}input`}> <input {...ip}/> </span>
  const content=[]
  // const _draw = _.Q_.includes(v) ? ((print==_.PUB ? morePublic : morePrivate) >= 0) : false
  let draw = false//_.Q_.includes(v) ? (more.length || (print==_.PUB ? morePublic : morePrivate) >= 0) : false
  // const showPrint = !storeConfig && printerPrint && (typeof morePrivate=='undefined' || morePrivate>0 || morePublic>0)
  const showPrint = !prop.pks && u!='store' && printerPrint && (typeof morePrivate=='undefined' || morePrivate>0 || morePublic>0)
  // const showPrint = printerPrint && (morePrivate>0 || morePublic>0)
  // if (prop.row && prop.body.id==FILES) debugger
  // if (prop.row) debugger
  // if (prop.row && prop.body.id!=FILES && prop.meta && prop.pks && prop.pks.length) debugger
  // return null
  // if (prop.body.id!=FILES && prop.row && prop.pks && prop.pks.length) debugger
// if (prop.row && prop.body.id=='items')debugger
  if (_.Q_.includes(v)) {
  // if (_.Q_.includes(v) && (prop.body.id==FILES || !prop.row)) {
    if (children.length) draw = true
    if (showPrint) draw = true
    // if (printerPrint && typeof morePrivate=='undefined') draw = true
    // if (morePrivate>0) draw = true
    if (morePublic>0) draw = true
  }
  // if (storeConfig) draw = false
  // const buttonVisible = more.length || (print==_.PUB && morePublic>0) || (print==_.PRI && (morePrivate>0 || typeof morePrivate=='undefined'))
  const buttonVisible = children.length || (print==_.PUB && morePublic>0) || (print==_.PRI && (morePrivate>0 || typeof morePrivate=='undefined'))
  /* check this
if (v==_.HOURS && !draw) debugger
*/
  // if (typeof morePrivate == 'undefined') debugger
  // const draw = prop.row ? (prop.more ? _draw : false) : _draw
  // const draw = prop.more ? _draw : false) : _draw
  // if (!prop.pks) debugger
  // if (u==v && owner && prop.pks.length < ((countPublic||0) + (countPrivate||0)) /*morePublic >= 0 && morePrivate>=0*/) content.push(input, label)
  // console.log({ID, print, offset, morePublic, morePrivate, countPublic, countPrivate, children, pks: prop.pks, 'prop.pks.length < ((countPublic||0) + (countPrivate||0))': prop.more && prop.more.length < ((countPublic||0) + (countPrivate||0)), '(countPublic||0) + (countPrivate||0)': (countPublic||0) + (countPrivate||0)})
  // <button {...bp}>{more.length || (print==_.PUB ? (morePublic>0?morePublic:'') : (morePrivate>0?morePrivate:''))} {master.more.i} {master[v].i} {print==_.PUB ? '':`${master.print.i}${print}`}</button>
  // draw && content.push(
  //   <div key={ID} className={`${_.MORE} ${_.BUTTON}`}>
  //     {owner && showPrint && label}
  //     {owner && showPrint && input}
  //     {/*(more.length || print==_.PUB && morePublic>0 || print==_.PRI && (morePrivate>0 || !morePrivate))  &&*/ buttonVisible &&
  //       <button {...bp}>
  //         {more.length || (print==_.PUB ? (morePublic>0?morePublic:'') : (morePrivate>0?morePrivate:''))}
  //         {' '}
  //         {master.more.i} {master[v].i}
  //         {print==_.PUB ? '':`${master[print].i}`}
  //       </button>
  //     }
  //   </div>
  // )
// if (id==ITEMS&&verb=='upd')debugger
// if (prop.row && prop.body.id=='items' && prop.row.verb=='upd') debugger
// if (prop.row && prop.body.id=='items') debugger
// if (prop.name=='items') debugger
// if (fid=='items')debugger
  const diff = prop.more && (prop.more.length - prop.value.length)
  const buttonDisplay = diff > 0 ? diff : ''
  // if (diff>0)debugger
  // if (fid=='medias')debugger
  // <button {...bp}>
  //   {(children.length && buttonDisplay) || (print==_.PUB ? (morePublic>0?morePublic:'') : (morePrivate>0?morePrivate:''))}
  //   {' '}
  //   {master.more.i} {master[v].i}
  //   {' '}
  //   {print==_.PUB ? '':`${master[print].i}`}
  // </button>
  draw && content.push(
      owner && showPrint && label,
      owner && showPrint && input,
      buttonVisible && <input type='button' {...bp} key={`${id}button`} value={`${(children.length && buttonDisplay) || (print==_.PUB ? (morePublic>0?morePublic:'') : (morePrivate>0?morePrivate:''))} ${master.more.i} ${master[v].i} ${print==_.PUB ? '':master[print].i}`}/>
  )
  return <div className='flex' style={{justifyContent: owner && showPrint ? 'space-around' : 'right'}}> {content} </div>
  // return <div className={_.MORE}>{content}</div>
}
export default More
